import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@app/redux/reducers/state';
import mapMenuConfig from './utils/mapMenuConfig';
import MenuConfigType from '@app/types/MenuConfigType';
import useLocalStorage from '../../hooks/useLocalStorage';
import TopMenu from '../TopMenu/index';
import { useTranslation } from 'react-i18next';

type PropTypes = {
  menuConfig: MenuConfigType[];
};

const mainMenuTreeKey = 'MenuTree';

const TopMenuContainer: React.FC<PropTypes> = ({ menuConfig }) => {
  const { menuItems, routeKey } = useSelector((state: RootState) => state.auth);
  const { features } = useSelector((state: RootState) => state.configuration);

  const [menu, setMenu] = useLocalStorage(mainMenuTreeKey, []);
  const {t} = useTranslation();

  useEffect(() => {
    if (menuItems && menuItems.length > 0) {
      setMenu(menuItems);
    }
  }, [menuItems, setMenu]);

  return <TopMenu menu={mapMenuConfig(menuConfig, menu, t, features)} key={routeKey} />;
};

export default TopMenuContainer;
